import React from 'react';
import { Box, Typography } from '@material-ui/core';

const NullDataFound = ({ message, icon, isIconShow }) => {
  return (
    <Box bgcolor="white" p={4} height="100vh">
      <Box textAlign="center" mt={10}>
        {isIconShow && <img src={icon} alt="icon" />}
        <Typography variant="subtitle2" mb={2}>
          {message}
        </Typography>
      </Box>
    </Box>
  );
};
export default NullDataFound;
